import React from 'react';
import { STATUS_APPLICATION_WAGON } from 'helpers/constants';
import { Select } from 'components/ui/formik';
import Form from '../form';
import styles from '../../../order.module.scss';

const User = ({ edit, values }) => {
  const isDisabled = [
    STATUS_APPLICATION_WAGON.WORK,
  ].every(status => status !== Number(edit.status));

  const isChangedStatus = edit.status !== Number(values.status);

  return (
    <>
      <div className={styles.item}>
        <Select disabled={isDisabled} label="Статус" name="status">
          {[
            ...(isDisabled ? STATUS_APPLICATION_WAGON.list() : [
              STATUS_APPLICATION_WAGON.list().find(status => status === Number(edit.status)),
              STATUS_APPLICATION_WAGON.CANCEL,
            ]),
          ].map(value => (
            <option value={value} key={value}>
              {STATUS_APPLICATION_WAGON.toString(value)}
            </option>
          ))}
        </Select>
      </div>
      {isChangedStatus ? (
        <Form />
      ) : null}
    </>
  );
};

export default User;
